/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { RouteComponentProps } from "react-router";
import DataViewModel from "../../ViewModels/DataViewModel";
import INavigationViewModel from "./INavigationViewModel";
import NavigationLink from "./NavigationLink";

export interface NavigationViewState {
    suchbegriff: string;
    daten: any[];
}

export default abstract class NavigationViewModel
    extends DataViewModel<NavigationViewState>
    implements INavigationViewModel {
    public constructor(public readonly titel: string, private readonly _history: RouteComponentProps["history"]) {
        super({
            initialState: {
                suchbegriff: "",
                daten: [],
            },
        });
    }

    public abstract get links(): NavigationLink[];

    public abstract finde(suchbegriff: string): void;

    public findeMitLaden = (suchbegriff: string): void => {
        this._setLoading(true);
        this.finde(suchbegriff);
    }

    public navigate(url: string, istAusgewaehlt: boolean): () => void {
        return () => {
            if (!istAusgewaehlt) {
                this._history.push(url);
            }
        };
    }
}
